import { jsx as _jsx } from "react/jsx-runtime";
import { brandConfiguration } from "@/brands/config";
import { useI18n } from "@/contexts/i18n";
import { Button } from "@gemini/ui";
import { useIsNewBuildProject } from "@/shared/hooks";
export const ContactFormSubmit = ({ loading, testId, isPrivateOwner, }) => {
    const { t } = useI18n();
    const { contactFormSubmitAgency, contactFormSubmitPrivate } = brandConfiguration.lokaliseSpecificKeys;
    const isProject = useIsNewBuildProject();
    const contactFormSubmitBtnText = isProject
        ? t("contact.form.project.email")
        : t(isPrivateOwner ? contactFormSubmitPrivate : contactFormSubmitAgency);
    return (_jsx(Button, { isDisabled: loading, isLoading: loading, testId: `${testId}.Submit`, isFullWidth: true, type: "submit", children: contactFormSubmitBtnText }));
};
